import { NoAvatar } from "../../../icons";

interface AvatarProps {
  src: string | undefined; // URL of the avatar image
  alt?: string; // Alt text for the avatar
  size?: "xsmall" | "small" | "medium" | "large" | "xlarge" | "xxlarge" | "xxxlarge"; // Avatar size
  status?: "online" | "offline" | "busy" | "none"; // Status indicator
}

const sizeClasses = {
  xsmall: "h-6 w-6 max-w-6",
  small: "h-8 w-8 max-w-8",
  medium: "h-10 w-10 max-w-10",
  large: "h-12 w-12 max-w-12",
  xlarge: "h-14 w-14 max-w-14",
  xxlarge: "h-16 w-16 max-w-16",
  xxxlarge: "h-20 w-20 max-w-20",
};

const statusSizeClasses = {
  xsmall: "h-1.5 w-1.5 max-w-1.5",
  small: "h-2 w-2 max-w-2",
  medium: "h-2.5 w-2.5 max-w-2.5",
  large: "h-3 w-3 max-w-3",
  xlarge: "h-3.5 w-3.5 max-w-3.5",
  xxlarge: "h-4 w-4 max-w-4",
  xxxlarge: "h-4.5 w-4.5 max-w-4.5",
};

const noAvatarSizeClasses = {
  xsmall: { width: 24, height: 24 },
  small: { width: 32, height: 32 },
  medium: { width: 40, height: 40 },
  large: { width: 48, height: 48 },
  xlarge: { width: 56, height: 56 },
  xxlarge: { width: 64, height: 64 },
  xxxlarge: { width: 78, height: 78 },
};

const statusColorClasses = {
  online: "bg-success-500",
  offline: "bg-error-400",
  busy: "bg-warning-500",
};

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt = "User Avatar",
  size = "medium",
  status = "none",
}) => {
  return (
    <div className={`relative rounded-full ${sizeClasses[size]}`}>
      {/* Avatar Image */}
      {src 
        ? <img src={src} alt={alt} className={`object-cover rounded-full ${sizeClasses[size]}`} /> 
        : <NoAvatar {...noAvatarSizeClasses[size]} />
      }

      {/* Status Indicator */}
      {status !== "none" && (
        <span
          className={`absolute bottom-0 right-0 rounded-full border-[1.5px] border-white dark:border-gray-900 ${
            statusSizeClasses[size]
          } ${statusColorClasses[status] || ""}`}
        ></span>
      )}
    </div>
  );
};

export default Avatar;
